import { v4 } from 'uuid'

export const ADD_ERROR = 'ADD_ERROR'
export const addError = message => ({
    type: ADD_ERROR,
    message,
})

export const ACK_ERROR = 'ACK_ERROR'
export function ackError() {
    return function ackError() {
        window.location.reload()
    }
}

export const ADD_ALERT = 'ADD_ALERT'
export const addAlert = (level, message) => ({
    type: ADD_ALERT,
    alert: {
        id: v4(),
        level,
        message,
    }
})

export const addSuccessAlert = (message) => addAlert('success', message)

export const addErrorAlert = (message) => addAlert('danger', message)

export const ACK_ALERT = 'ACK_ALERT'
export const ackAlert = (id) => ({
    type: ACK_ALERT,
    id,
})
